import createApi from 'api/createApi';
import qs from 'query-string';

import { tags as fileTags } from '../../file/api';

export const tags = {
	filterExtended__apply: 'mw/request/filterExtended/apply',
	filterExtended__apply__export: 'mw/request/filterExtended/apply/export',
	filterExtended__diagramm__export: 'mw/request/filterExtended/diagramm/export',
	filterExtended__diagramm: 'mw/request/filterExtended/diagramm',
	filterExtended__ovvCabinet__diagramm: 'mw/request/filterExtended/ovv-cabinet/diagramm',
	filterExtended__diagramm__sourceList: 'mw/request/filterExtended/diagramm/source-list',
	filterExtended__reportTemplate: 'mw/request/filterExtended/report-template',
	filterExtended__reportTemplate__export: 'mw/request/filterExtended/report-template/export',
	filterExtended__reportTemplate__fields: 'mw/request/filterExtended/report-template/fields',
	filterExtended__reportTemplate__tree: 'mw/request/filterExtended/report-template/tree/',
};

export const requestFilterExtendedApi = createApi({
	reducerPath: 'mw/requestFilterExtendedApi/',
	tagTypes: Object.values(tags),
	endpoints: (builder) => ({
		apply: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/apply',
				body,
			}),
			providesTags: [tags.filterExtended__apply],
		}),
		applyExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/apply/export',
				body,
			}),
			providesTags: [tags.filterExtended__apply__export],
		}),
		diagrammExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/diagramm/export',
				body,
			}),
			invalidatesTags: [fileTags.edit__file__report__list],
		}),
		diagramm: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/diagramm',
				body,
			}),
			providesTags: [tags.filterExtended__diagramm],
		}),
		ovvCabinetDiagramm: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/ovv-cabinet/diagramm',
				body,
			}),
			providesTags: [tags.filterExtended__ovvCabinet__diagramm],
		}),
		diagrammSourceList: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/filterExtended/diagramm/source-list?${qs.stringify(body)}`,
			}),
			providesTags: [tags.filterExtended__diagramm__sourceList],
		}),
		reportTemplate: builder.query({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/report-template/',
				body,
			}),
			providesTags: [tags.filterExtended__reportTemplate__tree],
		}),
		reportTemplateFields: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/filterExtended/report-template/fields?${qs.stringify(body)}`,
				body,
			}),
			providesTags: [tags.filterExtended__reportTemplate__fields],
		}),
		reportTemplateExport: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/request/filterExtended/report-template/export',
				body,
			}),
			providesTags: [tags.filterExtended__reportTemplate__export],
		}),
		reportTemplateTree: builder.query({
			query: (body) => ({
				method: 'GET',
				url: `/mw/request/filterExtended/report-template/tree/?${qs.stringify(body)}`,
			}),
			providesTags: [tags.filterExtended__reportTemplate__tree],
		}),
	}),
});

export const {
	apply,
	applyExport,
	diagramm,
	ovvCabinetDiagramm,
	diagrammSourceList,
	reportTemplate,
	reportTemplateExport,
	reportTemplateFields,
	reportTemplateTree,
	diagrammExport,
} = requestFilterExtendedApi.endpoints;

export default requestFilterExtendedApi;
